import {
  mdiBullseyeArrow,
  mdiCar,
  mdiCogOutline,
  mdiFileChartOutline,
  mdiTelevision,
  mdiTextBoxSearchOutline,
} from '@mdi/js'

import localStorageSlim from 'localstorage-slim'

const userProfile = localStorageSlim.get('userProfile', { decrypt: true })
const profileName = userProfile?.profile?.profile
const occupation = userProfile?.occupation_sector?.occupation?.name
const company = userProfile?.company?.fantasy_name
const sector = userProfile?.occupation_sector?.sector?.name

const listProfilesViewRevisions = ['Pós-venda', 'Administrador', 'Diretor', 'Administrativo', 'Vendedor', 'Supervisor']

const utilities = [
  {
    subheader: 'Utilitários',
  },
]

if (company === 'FUJI MOTORS' && occupation === 'AUXILIAR ADMINISTRATIVO PRÉ-VENDA') {
  utilities.push({
    title: 'INTEGRAÇÕES',
    icon: mdiFileChartOutline,
    children: [
      {
        title: 'AUTO FORCE',
        icon: mdiCar,
        hidden: false,
        children: [
          {
            title: 'CATÁLOGO - FUJI',
            hidden: false,
            to: 'auto-force-catalog-fuji',
            ActiveTabColor: '#0075FF',
            ActiveTabColor2: '#0075FF',
          },
        ],
      },
    ],
  })
}

const posVendasChildren = []

if (listProfilesViewRevisions.includes(profileName)) {
  posVendasChildren.push(
    {
      title: 'Separar peças',
      to: 'parts-order',
      hidden: false,
      ActiveTabColor: '#0075FF',
      ActiveTabColor2: '#0075FF',
    },
    {
      title: 'Revisões',
      to: 'reviews',
      hidden: false,
      ActiveTabColor: '#0075FF',
      ActiveTabColor2: '#0075FF',
    },
    {
      title: 'Atendimento',
      to: 'customer-service',
      hidden: false,
      ActiveTabColor: '#0075FF',
      ActiveTabColor2: '#0075FF',
    },
  )
}

if (posVendasChildren.length > 0) {
  utilities.push({
    title: 'PÓS-VENDAS',
    icon: mdiCogOutline,
    children: posVendasChildren,
  })
}

if (
  profileName === 'Auditoria'
  || profileName === 'Administrador'
  || profileName === 'Controladoria'
  || profileName === 'Diretor'
) {
  utilities.push(
    {
      title: 'LOGS',
      icon: mdiTextBoxSearchOutline,
      children: [
        {
          title: 'Erro',
          to: 'logs-error',
          hidden: true,
          ActiveTabColor: '#0075FF',
          ActiveTabColor2: '#0075FF',
        },
        {
          title: 'Sucesso',
          to: 'logs-success',
          hidden: true,
          ActiveTabColor: '#0075FF',
          ActiveTabColor2: '#0075FF',
        },
      ],
    },
    {
      title: 'INTEGRAÇÕES',
      icon: mdiFileChartOutline,
      children: [
        // {
        //   title: 'ALL STRATEGY',
        //   icon: mdiLightbulbOnOutline,
        //   hidden: false,
        //   children: [
        //     {
        //       title: 'REPROCESSAMENTO',
        //       to: 'integrations-reprocessing',
        //       hidden: false,
        //       ActiveTabColor: '#0075FF',
        //       ActiveTabColor2: '#0075FF',
        //     },
        //     {
        //       title: 'EXCEÇÕES',
        //       to: 'black-list',
        //       hidden: false,
        //       ActiveTabColor: '#0075FF',
        //       ActiveTabColor2: '#0075FF',
        //     },
        //   ],
        // },
        {
          title: 'AUTO FORCE',
          icon: mdiCar,
          hidden: false,
          children: [
            {
              title: 'CATÁLOGO - MOTOCA',
              hidden: false,
              to: 'auto-force-catalog-motoca',
              ActiveTabColor: '#0075FF',
              ActiveTabColor2: '#0075FF',
            },
            {
              title: 'CATÁLOGO - FUJI',
              hidden: false,
              to: 'auto-force-catalog-fuji',
              ActiveTabColor: '#0075FF',
              ActiveTabColor2: '#0075FF',
            },
          ],
        },
      ],
    },
  )
}

if (occupation === 'LIDER DE SEMINOVOS' || (occupation === 'AUXILIAR ADMINISTRATIVO' && sector === 'VEICULOS SEMINOVOS')) {
  utilities.push({
    title: 'INTEGRAÇÕES',
    icon: mdiFileChartOutline,
    children: [
      {
        title: 'AUTO FORCE',
        icon: mdiCar,
        hidden: false,
        children: [
          {
            title: 'CATÁLOGO - MOTOCA',
            hidden: false,
            to: 'auto-force-catalog-motoca',
            ActiveTabColor: '#0075FF',
            ActiveTabColor2: '#0075FF',
          },
        ],
      },
    ],
  })
}

if (occupation === 'GERENTE GERAL' || occupation === 'CONSULTOR(A) DE VENDAS SEMI-NOVOS') {
  utilities.push({
    title: 'INTEGRAÇÕES',
    icon: mdiFileChartOutline,
    children: [
      {
        title: 'AUTO FORCE',
        icon: mdiCar,
        hidden: false,
        children: [
          {
            title: 'CATÁLOGO - FUJI',
            hidden: false,
            to: 'auto-force-catalog-fuji',
            ActiveTabColor: '#0075FF',
            ActiveTabColor2: '#0075FF',
          },
        ],
      },
    ],
  })
}

if (
  profileName === 'Marketing'
  || profileName === 'Administrador'
  || profileName === 'Diretor'
  || occupation === 'COORDENADOR(A) ADMINISTRATIVO DE VENDAS DE CONSORCIO'
) {
  utilities.push({
    title: 'MARKETING',
    icon: mdiBullseyeArrow,
    children: [
      {
        title: 'NEXUS PLAYER',
        icon: mdiTelevision,
        hidden: true,
        children: [
          {
            title: 'Inserir mídias',
            to: 'insert-media',
            hidden: true,
            ActiveTabColor: '#0075FF',
            ActiveTabColor2: '#0075FF',
          },
          {
            title: 'Exibição',
            to: 'display-media',
            hidden: true,
            ActiveTabColor: '#0075FF',
            ActiveTabColor2: '#0075FF',
          },
        ],
      },
    ],
  })
} else {
  utilities.push({
    title: 'MARKETING',
    icon: mdiBullseyeArrow,
    children: [
      {
        title: 'NEXUS PLAYER',
        icon: mdiTelevision,
        hidden: true,
        children: [
          {
            title: 'Exibição',
            to: 'display-media',
            hidden: true,
            ActiveTabColor: '#0075FF',
            ActiveTabColor2: '#0075FF',
          },
        ],
      },
    ],
  })
}
if (sector === 'OFICINA') {
  posVendasChildren.push({
    title: 'Nexus Status',
    to: 'nexus-status',
    hidden: false,
    ActiveTabColor: '#0075FF',
    ActiveTabColor2: '#0075FF',
  })
}

export default utilities
